export const breadcrumbData = {
  breadcrumbSeparator: false,
  stepKey: 1,
  steps: [
    {
      title: 'DASHBOARD - BACKERS',
      titleDisplay: true
    }
  ],
  pageHeader: {
    header: 'Backers',
    navigationButton: false,
    helpText: 'Your Set of investors'
  }
};

export enum BACKER_ONBOARDING_STATUS {
  ALL = 'All',
  CA_SENT = 'CA Sent',
  CA_ESIGNED = 'CA e-Signed',
  INVITED = 'Invited',
  PROFILE_CREATED = 'Profile Created'
}

export const BACKER_ONBOARDING_STATUS_KEY = {
  [BACKER_ONBOARDING_STATUS.ALL]: 'backers',
  [BACKER_ONBOARDING_STATUS.CA_ESIGNED]: 'ca_signed',
  [BACKER_ONBOARDING_STATUS.CA_SENT]: 'ca_sent',
  [BACKER_ONBOARDING_STATUS.INVITED]: 'invited',
  [BACKER_ONBOARDING_STATUS.PROFILE_CREATED]: 'profile_created'
};

export const TYPE_OF_COMMUNICATION_KEY: any = {
  [BACKER_ONBOARDING_STATUS.CA_SENT]: 'no_ca_sign',
  [BACKER_ONBOARDING_STATUS.INVITED]: 'no_profile'
};

export type ColumnObjectType = {
  field: string;
  headerAlign?: string;
  align?: string;
  flex?: number;
  minWidth?: number;
  headerName: string;
  isSearchable?: boolean;
  renderCell?: Function;
  type?: string;
  filterable?: boolean;
  valueGetter?: Function;
};

export const backersColumnsData: ColumnObjectType[] = [
  {
    field: 'name',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 200,
    headerName: 'NAME',
    filterable: true
  },

  {
    field: 'email',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 350,
    headerName: 'EMAIL'
  },
  {
    field: 'mobile',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 200,
    headerName: 'MOBILE'
  },
  {
    field: 'onboarding_status',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    minWidth: 200,
    headerName: 'ONBOARDING STATUS'
  },
  {
    field: 'joined',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 170,
    headerName: 'INVITED TO SYNDICATE',
    type: 'date',
    renderCell: (params: any) => params?.row?.formated_joined_date,
    valueGetter: (params: any) => params?.row?.joined
  },
  {
    field: 'onboarding_date',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 150,
    headerName: 'ONBOARDED TO AIF',
    type: 'date',
    renderCell: (params: any) => params?.row?.formated_onboarding_date,
    valueGetter: (params: any) => params?.row?.onboarding_date
  },
  {
    field: 'total_amount_transferred',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 200,
    type: 'number',
    headerName: 'TOTAL TRANSFERRED',
    renderCell: (params: any) =>
      params?.row?.total_amount_transferred && params?.row?.total_amount_transferred > 0
        ? params?.row?.formated_total_amount_transferred
        : '-',
    valueGetter: (params: any) => params?.row?.total_amount_transferred
  },
  {
    field: 'deals_participated',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 100,
    type: 'number',
    headerName: '#DEALS'
  },
  {
    field: 'unallocated_amount',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 200,
    headerName: 'Unallocated Funds',
    renderCell: (params: any) => params?.row?.formated_unallocated_amount
  },
  {
    field: 'actions',
    headerAlign: 'right',
    align: 'right',
    minWidth: 200,
    headerName: 'ACTIONS'
  }
];

export enum InvestmentProfileType {
  INDIVIDUAL = 'individual',
  PARTNERSHIP = 'partnership',
  JOINT_ACCOUNT = 'joint_account'
}

export const InvestmentProfileTypeOptions = [
  { label: 'Select', value: '' },
  { label: 'Individual/Corporate', value: InvestmentProfileType.INDIVIDUAL },
  { label: 'Partnership', value: InvestmentProfileType.PARTNERSHIP },
  { label: 'Joint Account', value: InvestmentProfileType.JOINT_ACCOUNT }
];
